// extracted by mini-css-extract-plugin
export default {"container":"kZ-z","heading":"lZ-z","links":"mZ-z","copy":"nZ-z","subCopy":"oZ-z","linksLeft":"pZ-z","linksCenter":"qZ-z","linksRight":"rZ-z","link":"sZ-z","onlyLink":"tZ-z"};